import {ArticleResponse, ArticleUpdateReq} from './article.contracts';
import {DisplayResponse} from './display.contracts';
import {Type} from 'class-transformer';

export class ComputerResponse extends ArticleResponse {
    public type!: string;
    public wLAN!: string;
    public bluetooth!: string;
    public cellular!: string;
    @Type(() => DisplayResponse)
    public display: DisplayResponse | null = null;
    public powerConsumptionIdle!: number;
    public powerConsumptionFull!: number;

    public override clone(response: ComputerResponse): ComputerResponse {
        let responseClone = new ComputerResponse();

        responseClone.type = response.type;
        responseClone.wLAN = response.wLAN;
        responseClone.bluetooth = response.bluetooth;
        responseClone.cellular = response.cellular;
        responseClone.display = response.display;
        responseClone.powerConsumptionIdle = response.powerConsumptionIdle;
        responseClone.powerConsumptionFull = response.powerConsumptionFull;

        return responseClone;
    }
}

export class ComputerRequest extends ArticleUpdateReq {
    public type?: string;
    public wLAN?: string;
    public bluetooth?: string;
    public cellular?: string;
    public display?: string;
    public powerConsumptionIdle?: number;
    public powerConsumptionFull?: number;

    public override fromResponse(response: ComputerResponse): ComputerRequest {
        let request = new ComputerRequest();

        request.type = response.type;
        request.wLAN = response.wLAN;
        request.bluetooth = response.bluetooth;
        request.cellular = response.cellular;
        request.display = response.display?.guid;
        request.powerConsumptionIdle = response.powerConsumptionIdle;
        request.powerConsumptionFull = response.powerConsumptionFull;

        return request;
    }
}

export class ComputerCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}
